import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { LoadingText, PageRoot, StyledVideoPlayer } from './Styled'
import { fetchVideoList } from 'api'
import { useSelector } from 'react-redux'
import { selectTokenInfo } from 'redux/selector/user'

interface VideoPopupProps {}

const PartVideo: React.FC<VideoPopupProps> = () => {
  const user = useSelector(selectTokenInfo)
  const [videoInfo, setVideoInfo] = React.useState<any>(null)

  const id = useMemo(() => {
    if (typeof window === 'undefined') return undefined
    const params = new URLSearchParams(window.location.search)
    const raw = params.get('id') || ''
    if (!raw) return undefined
    return raw
  }, [])

  const isReady = videoInfo != null && user != null

  const startTime = useRef<number | null>(null)

  const loadVideoInfo = useCallback(async () => {
    const infoList = await fetchVideoList({
      // WARN: force cast string to number because js do not support int64.
      id: id as unknown as number,
    })
    const info = infoList.data[0]
    if (!info) {
      console.log('video info not found for id', id)
    }
    setVideoInfo(info)
    return info
  }, [id])
  const onPlay = useCallback(() => {
    startTime.current = Date.now()
  }, [])

  const endPlayTime = useCallback((end) => {
    if (startTime.current != null) {
      startTime.current = null
    }
  }, [])

  const onPause = useCallback(() => {
    endPlayTime(Date.now())
  }, [endPlayTime])

  const onEnded = useCallback(() => {
    endPlayTime(Date.now())
  }, [endPlayTime])

  useEffect(() => {
    if (!id) {
      console.log('video id is missing')
      return
    }
    if (user == null) {
      console.log('user info is missing')
      return
    }
    loadVideoInfo()
  }, [id, loadVideoInfo, user])

  return (
    <PageRoot>
      {isReady ? (
        <StyledVideoPlayer
          videoInfo={videoInfo}
          poster={videoInfo?.posterImg}
          skipBigPlayIcon
          showBackButton={false}
          onPlay={onPlay}
          onPause={onPause}
          onEnded={onEnded}
        />
      ) : (
        <LoadingText>Loading...</LoadingText>
      )}
    </PageRoot>
  )
}

export default PartVideo
